import { useCallback } from 'react';

import ArticleCardImpressionEvent from '~/events/ArticleCardImpressionEvent';
import useImpression from '~/hooks/useImpression';
import useRootData from '~/hooks/useRootData';
import useUser from '~/hooks/useUser';

type Options = {
  articleId: string | undefined;
  modulePosition?: number;
  moduleType: string;
  position: number;
};

export default function useArticleCardImpression<T extends HTMLElement>({
  articleId,
  modulePosition,
  moduleType,
  position
}: Options) {
  const { isBot } = useRootData();
  const { guestId } = useUser();

  const track = useCallback(() => {
    new ArticleCardImpressionEvent({
      articleId,
      guestId,
      isBot,
      modulePosition,
      moduleType,
      position
    }).track();
  }, [articleId, guestId, isBot, modulePosition, moduleType, position]);

  return useImpression<T>(track, { enabled: !isBot });
}
